import classnames from 'classnames';
import { BEMBlock } from 'helpers/classnames';
import { Icon } from 'palette/Icon';
import { Small, Typography } from 'palette/Typography';
import { Dropdown, DropdownContent, DropdownTrigger } from '@common/Dropdown';
import { useConfig } from '@common/Hooks/useConfig';
import { useHasMounted } from '@common/Hooks/useHasMounted';
import { useTranslation } from '@common/Hooks/useTranslation';
import { clearCachedData } from '@helpers/cache';

import './StoreSelect.scss';

export default function StoreSelect({
    className,
    preventOpen = false,
    stores
}) {
    const hasMounted = useHasMounted();
    const config = useConfig();
    const translate = useTranslation();
    const [block, BEMElement] = BEMBlock('store-select');

    const bustStorage = (event, url) => {
        event.preventDefault();

        if (window.location.pathname !== url) {
            clearCachedData();
            window.location.href = url;
        }
    };

    return (
        <Dropdown settings={{ hasMouseMoveEvents: true }}>
            <DropdownTrigger className={classnames(block, className)}>
                <Typography>
                    {translate('header.select-store.text')}
                </Typography>
                <Icon
                    className="header-top__top-icon"
                    name={`flag_${config.store}`}
                    size="x-small"
                />
                <Typography>
                    {translate(`header.store_country.${config.store}`)}
                </Typography>
            </DropdownTrigger>
            { !preventOpen && (
                <DropdownContent>
                    <div className={BEMElement('dropdown')}>
                        {/* render stores on mount to be able to cache SSR requests, because url is dynamic */}
                        {hasMounted && stores.map(item => (
                            <Small
                                level="2"
                                key={item.id}
                            >
                                <a
                                    className={BEMElement('item')}
                                    href={item.url}
                                    onClick={e => bustStorage(e, item.url)}
                                >
                                    <Icon
                                        name={`flag_${item.slug}`}
                                        size="x-small"
                                    />
                                    <span>{item.name}</span>
                                </a>
                            </Small>
                        ))}
                    </div>
                </DropdownContent>
            )}
        </Dropdown>
    );
}
